import { toastr } from 'react-redux-toastr'
import httpAuth from '../../services/httpAuth'
import { setLockedBonus } from './lockedBonus.slice'


export const requestLockedBonus = (name) => async (dispatch, getState) => {
    const checkAuth = getState().auth

    if (checkAuth) {
        try {
            const response = await httpAuth.post(`user/getLockedBonusProgress`, {
                limit:10,
                page:1
            });
            if (response.data.data) {
                dispatch(setLockedBonus(response.data.data));
            }
            return response
        } catch (e) {
            dispatch(getLiveCasinoSearchError())
            // const errorMsg = getErrorMessage(e)
            // throw errorMsg
        }
    } else {
        toastr.error("You Need To Login First")
    }

}

